import React from "react";
import { get } from "lodash"; // Make sure to install and import lodash

interface ErrorMessageProps {
  errors: Record<string, any>;
  name: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ errors, name }) => {
  const error = get(errors, name);

  if (!error) return null;

  const renderError = (err: any): React.ReactNode => {
    if (typeof err === "string") {
      return <div>{err}</div>;
    }

    if (Array.isArray(err)) {
      return err.map((item, index) => (
        <div key={index}>{renderError(item)}</div>
      ));
    }

    if (typeof err === "object" && err !== null) {
      if (err.message) {
        return <div>{err.message}</div>;
      }
      return Object.entries(err).map(([key, value]) => (
        <div key={key}>{renderError(value)}</div>
      ));
    }

    return null;
  };

  return <div className="text-red-500 text-xs mt-1">{renderError(error)}</div>;
};

export default ErrorMessage;
